import { gql } from '@apollo/client'
import { pathOr } from 'ramda'
import React from 'react'

import { usePromiseQuery } from '../../../utils/apollo/_helpers/promiseQuery'
import Select from '../../../packages/kiti/components/form/Select'
import { integrationsClient } from '../../../utils/apollo/api'

const QUERY = gql`
  query twilioTemplates($integrationId: Int) {
    twilioTemplates(integrationId: $integrationId) {
      friendlyName
      types {
        twilioText {
          body
        }
      }
      sid
    }
  }
`

export const useTemplateSelectLoader = filter => {
  const query = usePromiseQuery(QUERY, { client: integrationsClient })

  return (search, page = 1) => {
    return query({ search, page, ...filter })
      ?.then(pathOr([], ['data', 'twilioTemplates']))
      .then(data => {
        const result = data.map((item, index) => {
          return {
            id: index,
            name: item.friendlyName,
            types: item.types,
            sid: item.sid
          }
        })

        return result
      })
  }
}

const TemplateSelect = ({ onChange, value, filter, ...props }) => {
  const getOptions = useTemplateSelectLoader(filter)

  return <Select value={value} onChange={onChange} options={getOptions} disablePagination={true} {...props} />
}

export default TemplateSelect
